<template lang="pug">
    el-dialog(title="调整赛制", width="50%",:visible.sync='visible' :append-to-body="true" :modal-append-to-body='false' @close="closeForm()" class='fromlist')
        el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="100px", @submit.native.prevent class='chose')
                //- 迭代五
                el-form-item(label="签位:" prop="applySize" label-width="180px")
                    el-col(style="width:35%;")
                        el-input(type="number" :min='ruleForm.joinCount||1' v-model='ruleForm.applySize' style="width:100%;" @change='changeapplySize' clearable placeholder="请填写签位")
                        //- font.font_later() (已报名4人!)
                    el-col(style="width:54%;")
                      el-form-item(label="" prop="" )
                        font.font_later() (已报名{{ruleForm.joinCount}}人)
                //- 迭代三
                el-form-item(label="第一阶段赛制:" prop="firstFormat" label-width="180px")
                    el-col(style="width:35%;")
                        el-select(v-model='ruleForm.firstFormat' style="width:100%;" placeholder="请选择比赛类型" @change='changefirstFormat'  clearable)
                          el-option(v-for="(item, index) in firstFormat" :label="item.label" :value='item.value' :disabled="item.disabled")
                    //- el-col(style="width:20%;" class="line") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*组数&nbsp;&nbsp;
                    el-col(style="width:54%;")
                      el-form-item(label="组数:" prop="groupNum" )
                        el-input(v-model='ruleForm.groupNum' style="width:100%;" @change='changeGroupNum' :disabled='[0, 5, 6, 7].includes(ruleForm.firstFormat)' clearable placeholder="请填写组数")
                el-form-item(label="第二阶段赛制:" prop="city" label-width="180px")
                    el-col(style="width:35%;")
                        el-select(v-model='ruleForm.secondFormat' style="width:100%;" placeholder="请选择比赛类型" @change='changeSecondCompeti' :disabled='ruleForm.firstFormat===1&&ruleForm.groupNum!=1&&ruleForm.groupNum!=""?false:true'  clearable)
                          el-option(v-for="(item, index) in secondFormat" :label="item.label" :value='item.value')
                    //- el-col(style="width:20%;" class="line") &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*交叉数&nbsp;&nbsp;
                    el-col(style="width:54%;")
                      el-form-item(label="交叉数:" )
                        el-select(v-model='ruleForm.crossNum' style="width:100%;" placeholder="请选择交叉数" :disabled='ruleForm.firstFormat===1&&ruleForm.secondFormat==4?false:true' clearable)
                          el-option(v-for="(item, index) in CrossingNum" :label="item.label" :value='item.value')
                el-form-item(v-if="ruleForm.firstFormat===1&&ruleForm.secondFormat==5"  label="第二阶段设置附加规则:" prop="secondAllowPlayOff" label-width="180px")
                    el-col(style="width:35%;")
                        el-select(v-model='ruleForm.secondAllowPlayOff' style="width:100%;" placeholder="请选择"    clearable)
                          el-option(label="第三四名争夺季军" :value="1" :disabled="(ruleForm.groupNum * ruleForm.firstGroupRiseNum) === 2")
                          el-option(label="无附加赛" :value="0")
                    el-col(style="width:54%;")
                    //-   el-form-item(label="第二阶段允许附加赛:" prop="secondAllowPlayOff")
                    //-     el-select(v-model='ruleForm.secondAllowPlayOff'  style="width:100%;" placeholder="请选择"  clearable)
                    //-       el-option(label="是" :value="1" )
                    //-       el-option(label="否" :value="0" )
                el-form-item(v-if="ruleForm.firstFormat===1" label="第一阶段小组晋级人数:" prop="firstGroupRiseNum" label-width="180px")
                    el-col(style="width:35%;")
                        el-input(v-model='ruleForm.firstGroupRiseNum' style="width:100%;" @blur='promotedNumber'  clearable placeholder="请填写小组晋级人数")
        span.dialog-footer(slot="footer")
            el-button(type="primary" :disabled="sureBtn" @click='sure') 确 定
            el-button(@click="visible=false  ") 取 消
</template>

<script>
export default {
	name: 'AdjustGameSys',
	data () {
		return {
			visible: false,
			type: -1,
			sureBtn: false,
			ruleForm: {
				firstFormat: '',
				groupNum: '',
				crossNum: '',
				secondFormat: '',
				ctId: '',
				applySize: '',
				joinCount: '',
				// firstAllowPlayOff:'',
				secondAllowPlayOff: '',
				firstGroupRiseNum: ''
			},
			rules: {
				firstFormat: [
					{
						required: true,
						message: '赛制不能为空!',
						trigger: 'change'
					}
				],
				groupNum: [
					{
						required: true,
						message: '组数不能为空!',
						trigger: 'change'
					},
          {
            validator: (rule, value, callback) => {
							if (this.ruleForm.firstFormat === 1) { // 小组循环赛
								if ([3, 4, 5].includes(this.ruleForm.secondFormat)) { // 同名次淘汰附加赛/交叉淘汰附加赛/淘汰赛
									const num = Number(value)
									if (isNaN(num) || !(num > 0 && (num & (num - 1)) === 0)) { // 组数必须是2的幂次方
										callback(new Error('组数必须为2的幂次方，如：2、4、8、16...！'))
									} else {
										callback()
									}
								} else {
									callback()
								}
							} else {
                callback()
							}
            },
            trigger: 'change'
          }
				],
				applySize: [
					{
						required: true,
						message: '签位不能为空!',
						trigger: 'blur'
					},
					{
						pattern: /^[0-9]*[1-9][0-9]*$/,
						message: '请输入正整数',
						trigger: 'blur'
					}
				],
				// firstAllowPlayOff: [
				// 	{
				// 		required: true,
				// 		message: '第一阶段允许附加赛不能为空!',
				// 		trigger: 'change'
				// 	}
				// ],

				secondAllowPlayOff: [
					{
						required: true,
						message: '第二阶段允许附加赛不能为空!',
						trigger: 'change'
					},
          {
            validator: (rule, value, callback) => {
              if (value === 1 && (Number(this.ruleForm.groupNum) * Number(this.ruleForm.firstGroupRiseNum) === 2) && this.ruleForm.secondFormat === 5) {
                callback(new Error('第一阶段小组晋级人数导致第二阶段参赛队伍为2支，请选择"无附加赛"！'))
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
				],

				firstGroupRiseNum: [
					{
						required: true,
						message: '第一阶段小组晋级人数不能为空!',
						trigger: 'change'
					},
          {
            validator: (rule, value, callback) => {
							if (this.ruleForm.firstFormat === 1) { // 小组循环赛
								if ([4].includes(this.ruleForm.secondFormat)) { // 交叉淘汰附加赛
									const num = Number(value)
									if (num === 0 || num % 2 !== 0) { // 第一阶段小组晋级人数必须是大于0的偶数
										callback(new Error('第一阶段小组晋级人数必须为大于0的偶数！'))
									} else {
										callback()
									}
								} else {
									callback()
								}
							} else {
                callback()
							}
            },
            trigger: 'change'
          }
				]
			},
			firstFormat: [
				{ value: 0, label: '淘汰附加赛' },
				{ value: 1, label: '小组循环赛' },
				{ value: 5, label: '淘汰赛' },
				{ value: 6, label: '6签位循环赛', disabled: true },
				{ value: 7, label: '3局2胜赛', disabled: true }
			],
			secondFormat: [
				{ value: 2, label: '同名次小组循环赛' },
				{ value: 3, label: '同名次淘汰附加赛' },
				{ value: 4, label: '交叉淘汰附加赛' },
				{ value: 5, label: '淘汰赛' }
			],
			CrossingNum: [
				{ value: '2', label: '2' }
				// { value: '4', label: '4' },
				// { value: '8', label: '8' }
			]
		}
	},
	methods: {
		init (id, type) {
			this.type = type
			this.$nextTick(() => {
				this.visible = true
				if (this.$refs['ruleForm']) {
					this.$refs['ruleForm'].resetFields()
				}
			})
			this.ruleForm.groupNum = ''
			this.ruleForm.secondFormat = ''
			this.ruleForm.crossNum = ''
			this.ruleForm.firstFormat = ''
			this.ruleForm.applySize = ''
			this.ruleForm.joinCount = ''
			this.ruleForm.ctId = id
			this.sureBtn = false
			this.$http({
				url: this.$http.adornUrl(`/ctCompetition/getId/` + id),
				method: 'get'
			}).then((data) => {
				this.ruleForm.applySize = data.bean.applySize * 1
				this.ruleForm.joinCount = data.bean.joinCount * 1
				if (this.ruleForm.applySize == 6) {
					this.firstFormat[3].disabled = false
				} else {
					this.firstFormat[3].disabled = true
				}
				if (this.ruleForm.applySize == 2) {
					this.firstFormat[4].disabled = false
				} else {
					this.firstFormat[4].disabled = true
				}
				if (data.bean.competitionMatchFormatList.length != 0) {
					this.ruleForm.firstFormat =
						data.bean.competitionMatchFormatList[0].matchFormat
					this.ruleForm.groupNum =
						data.bean.competitionMatchFormatList[0].groupNum

					// this.ruleForm.firstAllowPlayOff =
					// 	data.bean.competitionMatchFormatList[0].allowPlayOff

					this.ruleForm.firstGroupRiseNum =
							data.bean.competitionMatchFormatList[0].groupRiseNum
					if (
						data.bean.competitionMatchFormatList[0]
							.matchFormat === 1
					) {
						// alert(1)
						this.rules.groupNum[0].required = true //控制表单是否必填组数
						this.$refs.ruleForm.validateField(
							'groupNum'
						)
					} else {
						this.rules.groupNum[0].required = false //控制表单是否必填组数
						this.$refs.ruleForm.validateField(
							'groupNum'
						)
					}
					if (data.bean.competitionMatchFormatList.length > 1) {
						this.ruleForm.secondFormat = data.bean.competitionMatchFormatList[1].matchFormat
						this.ruleForm.crossNum = data.bean.competitionMatchFormatList[1].crossNum
						if (this.ruleForm.firstFormat === 1) {
							this.ruleForm.secondAllowPlayOff = data.bean.competitionMatchFormatList[1].allowPlayOff
						}
					}
				}
			})
		},
		changeapplySize () {
			if (this.ruleForm.applySize < this.ruleForm.joinCount) {
				this.ruleForm.applySize = this.ruleForm.joinCount
			}
			// 签位数应小于64
			if (this.ruleForm.firstFormat == 0) {
				if (this.ruleForm.applySize > 64) {
					return this.applytesting()
				}
			}
      if ([6, 7].includes(this.ruleForm.firstFormat)) {
        this.ruleForm.firstFormat = ''
      }
      if (this.ruleForm.applySize == 6) {
        this.firstFormat[3].disabled = false
      } else {
        this.firstFormat[3].disabled = true
      }
      if (this.ruleForm.applySize == 2) {
        this.firstFormat[4].disabled = false
      } else {
        this.firstFormat[4].disabled = true
      }
			// 签位和组数的验证
			if (
				this.ruleForm.groupNum !== '' &&
				this.ruleForm.groupNum !== null &&
				this.ruleForm.applySize !== '' &&
				this.ruleForm.applySize !== null
			) {
				// if (this.ruleForm.secondFormat == 4) {
				// 	if (
				// 		this.ruleForm.applySize /
				// 			this.ruleForm.groupNum ===
				// 			2 ||
				// 		this.ruleForm.applySize /
				// 			this.ruleForm.groupNum ===
				// 			4 ||
				// 		this.ruleForm.applySize /
				// 			this.ruleForm.groupNum ===
				// 			6
				// 	) {
				// 	} else {
				// 		return this.applychecking1()
				// 	}
				// } else {
				// 	if (
				// 		this.ruleForm.applySize /
				// 			this.ruleForm.groupNum ===
				// 			2 ||
				// 		this.ruleForm.applySize /
				// 			this.ruleForm.groupNum ===
				// 			3 ||
				// 		this.ruleForm.applySize /
				// 			this.ruleForm.groupNum ===
				// 			4 ||
				// 		this.ruleForm.applySize /
				// 			this.ruleForm.groupNum ===
				// 			5 ||
				// 		this.ruleForm.applySize /
				// 			this.ruleForm.groupNum ===
				// 			6
				// 	) {
				// 	} else {
				// 		return this.applychecking()
				// 	}
				// }
			}
		},
		// 修改第二赛制验证限制
		changeSecondCompeti () {
			this.$forceUpdate()
			if (this.ruleForm.secondFormat != 4) {
				this.ruleForm.crossNum = ''
			} else {
				// if (
				// 	this.ruleForm.applySize /
				// 		this.ruleForm.groupNum ===
				// 		2 ||
				// 	this.ruleForm.applySize /
				// 		this.ruleForm.groupNum ===
				// 		4 ||
				// 	this.ruleForm.applySize /
				// 		this.ruleForm.groupNum ===
				// 		6
				// ) {
				// } else {
				// 	return this.applychecking1()
				// }
			}
			if (this.ruleForm.secondFormat != 5) {
				this.ruleForm.secondAllowPlayOff = ''
			}
			// 如果第二赛制为同名次小组循环赛需要验证
			if (this.ruleForm.secondFormat == 2) {
				if (
					this.ruleForm.groupNum >= 2 &&
					this.ruleForm.groupNum <= 6
				) {
				} else {
					return this.tiemchecking()
				}
			}
      this.$refs.ruleForm.validateField('secondAllowPlayOff')
		},
		changeGroupNum () {
			this.$forceUpdate()
			// 组数为1或者空需要验证
			if (
				this.ruleForm.groupNum == 1 ||
				this.ruleForm.groupNum == ''
			) {
				this.ruleForm.secondFormat = ''
				this.ruleForm.crossNum = ''
			}
			// 如果第二赛制为淘汰赛需要验证
			// if (this.ruleForm.secondFormat == 4) {
			// 	if (
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			2 ||
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			4 ||
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			6
			// 	) {
			// 	} else {
			// 		return this.applychecking1()
			// 	}
			// }
			// 如果第二赛制为同名次小组循环赛需要验证
			if (this.ruleForm.secondFormat == 2) {
				if (
					this.ruleForm.groupNum >= 2 &&
					this.ruleForm.groupNum <= 6
				) {
				} else {
					return this.tiemchecking()
				}
			}
			// 组数与签位的验证
			// if (
			// 	this.ruleForm.groupNum !== '' &&
			// 	this.ruleForm.groupNum !== null &&
			// 	this.ruleForm.applySize !== '' &&
			// 	this.ruleForm.applySize !== null
			// ) {
			// 	if (
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			2 ||
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			3 ||
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			4 ||
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			5 ||
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			6
			// 	) {
			// 	} else {
			// 		return this.applychecking()
			// 	}
			// }
      this.$refs.ruleForm.validateField('secondAllowPlayOff')
		},
		changefirstFormat () {
			// 第一赛制为空或者为0的验证
			if (
				this.ruleForm.firstFormat == 0 ||
				this.ruleForm.firstFormat == 5 ||
				this.ruleForm.firstFormat == ''
			) {
				this.ruleForm.groupNum = ''
				this.ruleForm.secondFormat = ''
				this.ruleForm.crossNum = ''
				// this.ruleForm.firstAllowPlayOff = ''
				this.ruleForm.secondAllowPlayOff = ''
				this.ruleForm.firstGroupRiseNum = ''
				this.rules.groupNum[0].required = false //控制表单是否必填组数
				this.$refs.ruleForm.validateField('groupNum')
				// this.rules.cbClubPhotoList = [{ required: true, message: '俱乐部照片不能为空' }]
				if (this.ruleForm.applySize > 64) {
					this.applytesting()
				}
			} else if ([6, 7].includes(this.ruleForm.firstFormat)) {
        this.ruleForm.groupNum = 1 // 组数
				this.ruleForm.secondFormat = '' // 第二阶段赛制
				this.ruleForm.crossNum = '' // 交叉数
				this.ruleForm.secondAllowPlayOff = '' // 第二阶段设置附加规则
				this.ruleForm.firstGroupRiseNum = '' // 第一阶段小组晋级人数
			} else {
				this.rules.groupNum[0].required = true //控制表单是否必填组数
				this.$refs.ruleForm.validateField('groupNum')
			}
		},
    // 晋级人数
    promotedNumber (val) {
      if (this.ruleForm.applySize && this.ruleForm.groupNum) {
        if (
          Number(this.ruleForm.firstGroupRiseNum) >
          Number(this.ruleForm.applySize) / Number(this.ruleForm.groupNum)
        ) {
          this.ruleForm.firstGroupRiseNum = '';
          this.$message({
            type: 'info',
            message: `晋级人数不能超过小组人数`,
          });
          this.$forceUpdate();
        }
      } else {
        this.$message({
          type: 'info',
          message: `请填写签位数和组数`,
        });
      }
      this.$refs.ruleForm.validateField('secondAllowPlayOff')
    },
		sure () {
			this.$refs['ruleForm'].validate((valid) => {
				if (valid) {
					// 组数和签位之间的限制
					if (!this.verification()) {
						return
					}
					const h = this.$createElement
					this.$msgbox({
						title: '提示',
						message: h('p', null, [
							h('p', '确认调整赛制？'),
							h(
								'p',
								'若已有成绩录入，系统将清空所有成绩及积分，重新生成新的对阵表！请谨慎操作，数据不可恢复。'
							)
						]),
						showCancelButton: true,
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					})
						.then(() => {
							this.sureBtn = true
							this.$http({
								url: this.$http.adornUrl(
									`/ctCompetition/changeFormat`
								),
								method: 'post',
								data: this.ruleForm
							}).then((data) => {
								if (data && data.code === 0) {
									this.$message({
										message: '操作成功',
										type: 'success',
										duration: 1500,
										onClose: () => {
											this.$emit(
												'refreshSortFormatrList'
											)
											this.visible = false
										}
									})
								} else {
									this.sureBtn = false
								}
							})
							.catch(() => {
								this.sureBtn = false
							})
						})
						.catch(() => {
							this.$message({
								type: 'info',
								message: '已取消修改'
							})
						})
				}
			})
		},
		tiemchecking () {
			this.$alert(
				'因二阶段同名次小组循环赛系统支持2-6签的小组对阵，故一阶段小组循环赛分组数也需满足2-6组。请重新设置组数！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
			return false
		},
		applytesting () {
			this.$alert(
				'当前系统支持最大签位数为64签。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applychecking () {
			this.$alert(
				'当前系统支持单组（即总签位数/组数）签位数为2/3/4/5/6签。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		applychecking1 () {
			this.$alert(
				'当前系统支持单组（即总签位数/组数）签位数为2/4/6签。请重新设置！',
				'提示',
				{
					confirmButtonText: '确定',
					callback: (action) => {
						this.$message({
							type: 'info',
							message: `请重新设置`
						})
					}
				}
			)
		},
		verification () {
			if (
				this.ruleForm.secondFormat == '' ||
				this.ruleForm.secondFormat == null
			) {
				if (this.ruleForm.groupNum > 1) {
					this.$message.error(
						'赛制仅为小组循环赛，组数只支持单组！'
					)
					return false
				}
			}
			// if (this.ruleForm.secondFormat == 4) {
			// 	if (
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			2 ||
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			4 ||
			// 		this.ruleForm.applySize /
			// 			this.ruleForm.groupNum ===
			// 			6
			// 	) {
			// 	} else {
			// 		return this.applychecking1()
			// 	}
			// }
			// 如果第二赛制为同名次小组循环赛需要验证
			if (this.ruleForm.secondFormat == 2) {
				if (
					this.ruleForm.groupNum >= 2 &&
					this.ruleForm.groupNum <= 6
				) {
				} else {
					return this.tiemchecking()
				}
			}
			if (
				this.ruleForm.firstFormat == 0 ||
				this.ruleForm.firstFormat == ''
			) {
				this.ruleForm.groupNum = ''
				this.ruleForm.secondFormat = ''
				this.ruleForm.crossNum = ''
				if (this.ruleForm.applySize > 64) {
					this.applytesting()
					return false
				}
			}

			// 组数和签位之间的限制
			if (
				this.ruleForm.groupNum !== '' &&
				this.ruleForm.groupNum !== null &&
				this.ruleForm.applySize !== '' &&
				this.ruleForm.applySize !== null
			) {
				// if (
				// 	this.ruleForm.applySize /
				// 		this.ruleForm.groupNum ===
				// 		2 ||
				// 	this.ruleForm.applySize /
				// 		this.ruleForm.groupNum ===
				// 		3 ||
				// 	this.ruleForm.applySize /
				// 		this.ruleForm.groupNum ===
				// 		4 ||
				// 	this.ruleForm.applySize /
				// 		this.ruleForm.groupNum ===
				// 		5 ||
				// 	this.ruleForm.applySize /
				// 		this.ruleForm.groupNum ===
				// 		6
				// ) {
				// } else {
				// 	this.applychecking()
				// 	return false
				// }
				if (this.ruleForm.secondFormat == 4) {
					if (
						this.ruleForm.crossNum == '' ||
						this.ruleForm.crossNum == ''
					) {
						this.$message.error('请选择交叉数')
						return false
					}
				}
			}
			return true
		},
		closeForm () {
			this.visible = false
		}
	}
}
</script>
<style>
/* .fromlist{
  position: relative;
  height: 200px;
} */
.chose {
	padding-top: 50px;
	align-items: flex-start !important;
	/* padding-left: 30%; */
}
.chose .el-form-item {
	width: 100%;
}
</style>
